import request from "@/utils/request";

// 权限管理-列表
export function permissionListApi(data) {
    return request({
      url: "/admin/admin_permissions",
      method: "get",
      params: data
    });
  }

// 权限管理-新增
export function addPermissionApi(data) {
    return request({
      url: "/admin/admin_permissions",
      method: "post",
      data
    });
  }

// 权限管理-修改 - 获取
export function getSinglePermissionApi(data) {
    return request({
      url: "/admin/admin_permissions/" + data.id,
      method: "get",
      params: data
    });
  }

// 权限管理-修改 -提交
export function putSinglePermissionApi(data) {
    return request({
      url: "/admin/admin_permissions/" + data.id,
      method: "put",
      data
    });
  }

// 权限管理-删除
export function deletePermissionApi(data) {
    return request({
      url: "/admin/admin_permissions/" + data.id,
      method: "delete",
      data
    });
  }

// 获取父级权限列表
export function getParentPermissionApi() {
    return request({
      url: "/admin/get_parent_permission" ,
      method: "get",
    });
  }